import "core-js/modules/es6.array.filter";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import { continuationTokenHeaderName } from '../../models';
import { BaseQuery } from './base-query.class';
export var BaseListingQuery =
/*#__PURE__*/
function (_BaseQuery) {
  _inherits(BaseListingQuery, _BaseQuery);

  function BaseListingQuery(config, queryService) {
    var _this;

    _classCallCheck(this, BaseListingQuery);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseListingQuery).call(this, config, queryService));
    _this.config = config;
    _this.queryService = queryService;
    return _this;
  }
  /**
   * Sets continuation token header
   */


  _createClass(BaseListingQuery, [{
    key: "withContinuationToken",
    value: function withContinuationToken(token) {
      var _a; // remove previous continuation token if there is any


      var queryHeaders = (_a = this._queryConfig.customHeaders) !== null && _a !== void 0 ? _a : [];
      queryHeaders = queryHeaders.filter(function (m) {
        return m.header !== continuationTokenHeaderName;
      });
      this._queryConfig.customHeaders = queryHeaders;
      this.withHeaders([{
        header: continuationTokenHeaderName,
        value: token
      }]);
      return this;
    }
    /**
     * Query to get all items. Uses paging data and may execute multiple HTTP requests depending on number of items
     */

  }, {
    key: "toAllPromise",
    value: function toAllPromise(queryAllConfig) {
      var _this2 = this;

      return this.queryService.getListAllResponse({
        page: 1,
        listQueryConfig: queryAllConfig,
        allResponseFactory: function allResponseFactory(items, responses) {
          var response = _this2.allResponseFactory(items, responses);

          return {
            data: response,
            responses: responses
          };
        },
        getResponse: function getResponse(nextPageUrl, continuationToken) {
          var query = _this2;

          if (nextPageUrl) {
            query = _this2.withCustomUrl(nextPageUrl);
          }

          if (continuationToken) {
            query = _this2.withContinuationToken(continuationToken);
          }

          return query.toPromise();
        }
      });
    }
  }]);

  return BaseListingQuery;
}(BaseQuery);